import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function InterestChart({ data }) {
    // Transform the data to match the format required by Recharts
    const chartData = data.default.timelineData.map(item => ({
        name: item.formattedAxisTime,
        'Interest Level': parseInt(item.value[0]) // Keep the values as numbers
    }));

    // Custom tooltip formatter to add '%' at the end of the value
    const tooltipFormatter = (value) => `${value}%`;

    return (
        <ResponsiveContainer width="100%" height="100%">
            <AreaChart
                width={500}
                height={400}
                data={chartData}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis tickFormatter={(tick) => `${tick}%`} /> {/* Format Y-axis ticks */}
                <Tooltip formatter={tooltipFormatter} /> {/* Format tooltip */}
                <Area type="monotone" dataKey="Interest Level" stroke="#0d76e0" fill="#0d76e0" />
            </AreaChart>
        </ResponsiveContainer>
    );
}

export default InterestChart;
